export default "__VITE_ASSET__CR63WYpJ__"